<template lang="html">
  <div :style="stylechat" v-model="ListBottomMenu">
    <v-row justify="center" align="center">
      <v-overlay
        :value="overlay"
        :z-index="zIndex"
        @click="closeDialog()"
      >
        <div class="layout-menu">
          <div v-for="(item, index) in ListBottomItem">
            <v-col :key="index" cols="12" align="center" @click="closeEmitDialog(item)">
              <v-icon color="primary" class="pr-4">{{item.icon}}</v-icon>
              <span class="span-color">{{item.text}}</span>
            </v-col>
            <v-divider class="divider-color" v-if="index < ListBottomItem.length - 1"></v-divider>
          </div>
        </div>
        <div class="layout-menu-close">
          <v-col cols="12" align="center" @click="closeDialog">
            <span class="span-color-close">{{$t('AnswerQuestion.cancel')}}</span>
          </v-col>
        </div>
      </v-overlay>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    ListBottomMenu: Boolean,
    ListBottomItem: Array
  },
  data () {
    return {
      overlay: false,
      zIndex: 1,
      stylechat: {
        "--ListBottomMenu-HeaderColor": "white",
        "--ListBottomMenu-TabBackground": "white",
        "--ListBottomMenu-Icon": "gray",
        "--ListBottomMenu-IconActive": "#2662ae",
        "--ListBottomMenu-Background": "white",
        "--ListBottomMenu-FontSize": "18px",
        "--ListBottomMenu-FontColor": "black",
        "--ListBottomMenu-FontSize-Status": "16px",
        "--ListBottomMenu-FontColor-Status": "grey",
        "--ListBottomMenu-Background-Input": "#E2E1E3",
        "--ListBottomMenu-Color-Button": "#EFF2FE",
        "--ListBottomMenu-FontColor-Button": "#2662ae",
        "--ListBottomMenu-FontColor-Cancel-Button": "#cb1002",
        "--ListBottomMenu-Color-Divider": "#eaeaea"
      },
    }
  },
  watch: {
    ListBottomMenu () {
      if (this.ListBottomMenu) {
        // console.log(this.ListBottomItem)
        this.overlay = true
      } else {
        this.overlay = false
      }
    }
  },
  methods: {
    closeDialog () {
      this.overlay = false
      this.$emit('closeAlertDialog', { type: 'bottommenu', value: false, actions: '' })
    },
    closeEmitDialog (item) {
      this.overlay = false
      this.$emit('emitListBottom', { type: 'bottommenu', value: false, item: item })
    },
    routePage (path) {
      this.closeDialog()
      this.$router.push(path)
    }
  }
}
</script>

<style lang="css" scoped>
.divider-color {
  border-color: var(--ListBottomMenu-Color-Divider) !important;
}
.span-color {
  color: var(--ListBottomMenu-FontColor-Button) !important;
  font-size: var(--ListBottomMenu-FontSize) !important;
  font-weight: 500;
}
.span-color-close {
  color: var(--ListBottomMenu-FontColor-Cancel-Button) !important;
  font-size: var(--ListBottomMenu-FontSize) !important;
  font-weight: 550;
}
>>>.v-overlay__content {
  align-items: center;
  justify-content: center;
  display: flex;
}
.layout-menu {
  height: auto;
  background-color: var(--ListBottomMenu-Background) !important;
  width: 95% !important;
  border-radius: 15px;
  position: fixed;
  bottom: 70px;
  margin-left: 20px;
  margin-right: 20px;
  padding: 10px;
  /* display: flex;
  justify-content: center; */
}
.layout-menu-close {
  /* height: 45px; */
  background-color: var(--ListBottomMenu-Background) !important;
  width: 95% !important;
  border-radius: 15px;
  position: fixed;
  bottom: 10px;
  margin-left: 20px;
  margin-right: 20px;
  /* padding: 10px; */
  /* display: flex;
  justify-content: center; */

}
</style>
